import { SelectItem } from 'primeng/api';

export const TIPI_SOGGETTO_OPTIONS: SelectItem<number>[] = [
  { label: 'Persona Fisica', value: 1 },
  { label: 'Persona Giuridica', value: 2 },
  { label: 'PAI', value: 3 },
  { label: 'PAE', value: 4 }
];
